import type { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

// Query invitations
export const query = graphql(`
    query CreateAccountInvitationsQuery($id: String!) {
        accountInvitation(id: $id) {
            id
            publicId
            email
            teamScan
            learningPath
            closed
            standaloneAiChatbotName
        }
        reusableAccountInvitation(id: $id) {
            id
            publicId
            learningPath
            closed
        }
    }
`);

export type IReusableAccountInvitation = NonNullable<ResultOf<typeof query>["reusableAccountInvitation"]>;
export type IAccountInvitation = NonNullable<ResultOf<typeof query>["accountInvitation"]>;

// Create personal account mutation
export const createPersonalMutation = graphql(`
    mutation CreatePersonalAccountMutation($data: CreateAccountData!) {
        accountInvitationCreateAccount(data: $data) {
            error
            redirectUrl
        }
    }
`);

// Create reusable account mutation
export const createReusableMutation = graphql(`
    mutation CreateReusableAccountMutation($data: CreateAccountData!) {
        reusableAccountInvitationCreateAccount(data: $data) {
            error
            redirectUrl
        }
    }
`);

// Associate personal account mutation
export const associatePersonalMutation = graphql(`
    mutation AssociatePersonalAccountMutation($data: AssociateAccountData!) {
        accountInvitationAssociateAccount(data: $data) {
            error
            redirectUrl
        }
    }
`);

// Associate reusable account mutation
export const associateReusableMutation = graphql(`
    mutation AssociateReusableAccountMutation($data: AssociateAccountData!) {
        reusableAccountInvitationAssociateAccount(data: $data) {
            error
            redirectUrl
        }
    }
`);
